import { combineReducers } from "@reduxjs/toolkit";
import MainReducer from "./slices/main.slice";
import SalariesStatisticsReducer from "./slices/SalariesStatistics.slice";
import CarnetsMealsStatisticsReducer from "./slices/CarnetsMealsStatistics.slice";
import ConstructionStatisticsReducer from "./slices/ConstructionStatistics.slice";
import OtherProjectsStatisticsReducer from "./slices/OtherProjectsStatistics.slice";
import FinancialStatisticsReducer from "./slices/FinancialStatistics.slice";
import ResourcesStatisticsReducer from "./slices/ResourcesStatistics.slice";
import ValuationsStatisticsReducer from "./slices/ValuationsStatistics.slice";
import SummaryStatisticsReducer from "./slices/SummaryStatistics.slice";
import CreditsStatisticsReducer from "./slices/CreditsStatistics.slice";
import TotalFinancialsStatisticsReducer from "./slices/TotalFinancialsStatistics.slice";

const rootReducer = combineReducers({
  construction: ConstructionStatisticsReducer,
  otherProjects: OtherProjectsStatisticsReducer,
  financial: FinancialStatisticsReducer,
  carnetsmeals: CarnetsMealsStatisticsReducer,
  salaries: SalariesStatisticsReducer,
  main: MainReducer,
  resources: ResourcesStatisticsReducer,
  valuation: ValuationsStatisticsReducer,
  credits: CreditsStatisticsReducer,
  summary: SummaryStatisticsReducer,
  totalfinancials: TotalFinancialsStatisticsReducer
});

export default rootReducer;
